import { useTranslation } from '../contexts/TranslationContext';
import { InfoTooltipButton } from './InfoTooltipButton';

interface LandingGuestQuestionExamplesProps {
  question: string;
  disabled: boolean;
  onSelect: (question: string) => void;
}

const EXAMPLE_KEYS = ['exemption', 'batteries2027', 'documents'] as const;

export function LandingGuestQuestionExamples({ question, disabled, onSelect }: LandingGuestQuestionExamplesProps) {
  const { t } = useTranslation();

  return (
    <div className="mt-3 flex min-w-0 flex-wrap gap-x-2 gap-y-1 px-1 sm:mt-4 sm:gap-y-2 sm:px-2" role="group" aria-label={t('presentation.guestQuestion.examplesLabel')} data-guest-question-examples>
      {EXAMPLE_KEYS.map((key) => {
        const exampleQuestion = t(`presentation.guestQuestion.examples.${key}.question`);
        const selected = question === exampleQuestion;

        return (
          <div
            key={key}
            data-selected={selected}
            className="landing-guest-example inline-flex w-full min-w-0 max-w-full items-center sm:w-auto sm:max-w-[15rem] rounded-full pl-3 pr-1 transition-[background-position,border-color,color,box-shadow,transform] duration-200 hover:-translate-y-px motion-reduce:transform-none motion-reduce:transition-none"
          >
            <button
              data-guest-example-select
              type="button"
              disabled={disabled}
              aria-label={t(`presentation.guestQuestion.examples.${key}.label`)}
              aria-pressed={selected}
              onClick={() => onSelect(exampleQuestion)}
              className="brand-focus-ring inline-flex min-h-8 min-w-0 flex-1 items-center rounded-full border-0 bg-transparent py-1.5 text-left disabled:cursor-not-allowed disabled:opacity-50"
            >
              <span data-guest-example-preview className="block min-w-0 truncate pr-2 text-xs font-medium leading-5 sm:text-[13px]">{exampleQuestion}</span>
            </button>
            <span className="landing-guest-example-info shrink-0">
              <InfoTooltipButton label={t('presentation.guestQuestion.exampleInfoLabel')} content={exampleQuestion} variant="plain" compact={false} iconClassName="h-3.5 w-3.5 text-[rgb(var(--landing-example-icon))]" />
            </span>
          </div>
        );
      })}
    </div>
  );
}
